import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import { FaChevronDown, FaBars, FaSignOutAlt } from 'react-icons/fa';
//import pomeloLogo from "../images/logo-p2.png";
import sclogo from "../images/logoAnimado.gif";
import { jwtDecode } from "jwt-decode";
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const [contentDropdownOpen, setContentDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState('');
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    try {
      const token = localStorage.getItem("token");
      
      if (!token) {
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsPremium(false);
        return;
      }
      
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      if (decodedToken.exp && decodedToken.exp < currentTime) {
        // Token expirado
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsPremium(false);
        return;
      }
      
      // Token válido
      setIsAuthenticated(true);
      
      // Verificar si es admin (ajusta según la estructura de tu token)
      setIsAdmin(decodedToken.rol === "Administrador" || decodedToken.isAdmin === true);
      //setIsPremium(decodedToken.isPremium === true);
      if (decodedToken.isPremium === "True") {
        setIsPremium(true);
      }
      // Guardar nombre de usuario si está disponible
      if (decodedToken.name || decodedToken.username) {
        setUserName(decodedToken.name || decodedToken.username);
      }
      
    } catch (error) {
      console.error("Error verificando autenticación:", error.message);
      setIsAuthenticated(false);
      setIsAdmin(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setIsAdmin(false);
    setUserName('');
    // Redirigir a la página de inicio
    window.location.href = "/";
  };

  const toggleAdminDropdown = () => {
    setAdminDropdownOpen(!adminDropdownOpen);
    if (contentDropdownOpen) setContentDropdownOpen(false);
  };

  const toggleContentDropdown = () => {
    setContentDropdownOpen(!contentDropdownOpen);
    if (adminDropdownOpen) setAdminDropdownOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="p-4 border-b border-zinc-700 relative z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <a href="/">
            <img src={sclogo} alt="Website Logo" className="mr-4" style={{ height: 40, width: 80 }} />
          </a>
          
          {isAuthenticated && (
            
            <div className="hidden md:flex items-center">
              
              <div className="relative mr-4">
                <button
                  onClick={toggleContentDropdown}
                  className="flex items-center focus:outline-none"
                >
                  Contenidos <FaChevronDown className="ml-2" />
                </button>
                {contentDropdownOpen && (
                  <div className="absolute mt-2 w-48 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-50">
                    <a href="/contenido/series" className="block px-4 py-2 text-white hover:bg-zinc-700">Galeria stand up</a>
                    <a href="/contenido/EnVivo" className="block px-4 py-2 text-white hover:bg-zinc-700">Shows en vivo</a>
                    <a href="/Ventas/Entradas" className="block px-4 py-2 text-white hover:bg-zinc-700">Venta de entradas</a>
                  </div>
                )}
                {/* Boton para redirigir a /comediante */}
                
              </div>
              <a href="/comediantes" className="mr-4">Comediantes</a>
              {/*}
              {isAdmin && (
                <div className="relative mr-4">
                  <button
                    onClick={toggleAdminDropdown}
                    className="flex items-center focus:outline-none"
                  >
                    Panel de Administración <FaChevronDown className="ml-2" />
                  </button>
                  {adminDropdownOpen && (
                    <div className="absolute mt-2 w-48 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-50">
                      <a href="/admin/usuario" className="block px-4 py-2 text-white hover:bg-zinc-700">Usuarios</a>
                      <a href="/admin/genero" className="block px-4 py-2 text-white hover:bg-zinc-700">Género</a>
                      <a href="/admin/serie" className="block px-4 py-2 text-white hover:bg-zinc-700">Serie</a>
                      <a href="/admin/filme" className="block px-4 py-2 text-white hover:bg-zinc-700">Filme</a>
                      <a href="/admin/capitulos" className="block px-4 py-2 text-white hover:bg-zinc-700">Capitulos</a>
                    </div>
                  )}
                </div>
              )}*/}
            </div>
          ) }
        </div>
        
        <div className="hidden md:flex items-center">
          {isAuthenticated ? (
            <>
              <a href="/Identity/Account/Manage" className="mr-4">Perfil de usuario</a>
              {isPremium ? (
                <a href="/mi-suscripcion" className="mr-4">Mi Suscripción</a>
              ) : (
                <a href="/planes" className="mr-4">Planes</a>
              )}

              <a href="/soporte" className="mr-4">Soporte</a>
              <button 
                onClick={handleLogout} 
                className="flex items-center text-red-400 hover:text-red-300"
              >
                Cerrar sesión <FaSignOutAlt className="ml-2" />
              </button>
            </>
          ) : (
            <a href="/login">Iniciar Sesión</a>
          )}
        </div>
        
        <button className="md:hidden" onClick={toggleMobileMenu}>
          <FaBars />
        </button>
      </div>
      
      {mobileMenuOpen && (
        <div className="md:hidden mt-4">
          {isAuthenticated ? (
            <>
              <a href="/home" className="block py-2">Home</a>
              <div className="py-2">
                <button
                  onClick={toggleContentDropdown}
                  className="w-full text-left focus:outline-none flex items-center justify-between"
                >
                  Contenidos <FaChevronDown className={`transition-transform duration-200 ${contentDropdownOpen ? 'transform rotate-180' : ''}`} />
                </button>
                {contentDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <a href="/contenido/series" className="block py-1">Galeria stand up</a>
                    <a href="/contenido/EnVivo" className="block py-1">Shows en vivo</a>
                    <a href="/Ventas/Entradas" className="block py-1">Venta de entradas</a>
                  </div>
                )}
              </div>
              <a href="/comediantes" className="block py-2">Comediantes</a>
              {/*{isAdmin && (
                <div className="py-2">
                  <button
                    onClick={toggleAdminDropdown}
                    className="w-full text-left focus:outline-none flex items-center justify-between"
                  >
                    Panel de Administración <FaChevronDown className={`transition-transform duration-200 ${adminDropdownOpen ? 'transform rotate-180' : ''}`} />
                  </button>
                  {adminDropdownOpen && (
                    <div className="pl-4 mt-2 space-y-2">
                      <a href="/admin/usuario" className="block py-1">Usuarios</a>
                      <a href="/admin/genero" className="block py-1">Género</a>
                      <a href="/admin/serie" className="block py-1">Serie</a>
                      <a href="/admin/filme" className="block py-1">Filme</a>
                      <a href="/admin/capitulos" className="block py-1">Capitulos</a>
                    </div>
                  )}
                </div>
              )}*/}
              
              <a href="/Identity/Account/Manage" className="block py-2">Perfil de usuario</a>
              <a href="/soporte" className="block py-2">Soporte</a>
              <button 
                onClick={handleLogout} 
                className="w-full text-left py-2 text-purple-400 hover:text-purple-500 flex items-center"
              >
                Cerrar sesión <FaSignOutAlt className="ml-2" />
              </button>
            </>
          ) : (
            <a href="/login" className="block py-2">Iniciar Sesión</a>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;